// Carosello «Guarda come si porta» della home LeiDry: frecce che scorrono di una pagina
// e si spengono agli estremi. Senza JavaScript la fila scorre comunque col dito o la rotella.
class LdyHomeLook extends HTMLElement {
  /** @type {AbortController | null} */
  #ascolto = null;

  connectedCallback() {
    const fila = this.querySelector('[data-fila]');
    if (!(fila instanceof HTMLElement)) return;
    this.#ascolto?.abort();
    this.#ascolto = new AbortController();
    const { signal } = this.#ascolto;

    for (const freccia of this.querySelectorAll('button[data-dir]')) {
      freccia.addEventListener(
        'click',
        () => {
          const dir = Number(freccia.getAttribute('data-dir')) || 1;
          const fermo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          fila.scrollBy({ left: dir * fila.clientWidth * 0.9, behavior: fermo ? 'auto' : 'smooth' });
        },
        { signal }
      );
    }

    const aggiorna = () => {
      const max = fila.scrollWidth - fila.clientWidth - 2;
      const prec = this.querySelector('button[data-dir="-1"]');
      const succ = this.querySelector('button[data-dir="1"]');
      if (prec instanceof HTMLButtonElement) prec.disabled = fila.scrollLeft <= 2;
      if (succ instanceof HTMLButtonElement) succ.disabled = fila.scrollLeft >= max;
    };
    fila.addEventListener('scroll', aggiorna, { passive: true, signal });
    window.addEventListener('resize', aggiorna, { passive: true, signal });
    aggiorna();
  }

  disconnectedCallback() {
    this.#ascolto?.abort();
    this.#ascolto = null;
  }
}

if (!customElements.get('ldy-home-look')) customElements.define('ldy-home-look', LdyHomeLook);
